import * as XLSX from "xlsx";

export interface ExcelPreviewData {
  sheetName: string;
  rows: string[][];
  truncated: boolean;
}

const cellToString = (value: unknown): string => {
  if (value == null) return "";
  if (value instanceof Date) return value.toLocaleDateString();
  return String(value);
};

/** Parse the first worksheet of an Excel file for inline preview. */
export async function parseExcelBlobForPreview(
  blob: Blob,
  maxRows = 50
): Promise<ExcelPreviewData> {
  const buffer = await blob.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheetName = workbook.SheetNames[0] ?? "Sheet1";
  const worksheet = workbook.Sheets[sheetName];

  if (!worksheet) {
    return { sheetName, rows: [], truncated: false };
  }

  let truncated = false;
  const ref = worksheet["!ref"];
  if (ref) {
    const range = XLSX.utils.decode_range(ref);
    const rowCount = range.e.r - range.s.r + 1;
    if (rowCount > maxRows) {
      truncated = true;
      range.e.r = range.s.r + maxRows - 1;
      worksheet["!ref"] = XLSX.utils.encode_range(range);
    }
  }

  const rawRows = XLSX.utils.sheet_to_json<unknown[]>(worksheet, {
    header: 1,
    defval: "",
    raw: false,
  });

  const rows = rawRows.map((row) =>
    Array.isArray(row) ? row.map(cellToString) : [cellToString(row)]
  );

  return { sheetName, rows, truncated };
}
